export const TAB_NAME = "Monke Ventures";
